import React, { Component } from 'react';
import { Input, Button, Row, Col, Divider, Card } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import * as actions from '../../../store/actions';
import ViewNotes from './ViewNotes';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import style from './NotesContainer.scss';

const { TextArea } = Input;

class Notes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      note: '',
    };
  }

  handleChange = e => {
    this.props.setCurrNoteState(e.target.value);
  };

  handleKeyPress = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      this.addNote();
    }
  };

  addNote = () => {
    if (this.props.curr_note && this.props.curr_note.trim()) {
      this.props.postNote(this.props.curr_note.trim());
      this.props.setCurrNoteState('');
    }
  };

  render() {
    return (
      <div
        className={style.notesCard}
        data-testid="notes-container"
      >
        {/* Header */}
        <div className={style.header}>
          <span>Notes</span>
          <Divider className={style.headerDivider} />
        </div>

        {/* Body - Create Note Card + Previous Notes */}
        <div className={style.body}>
          {/* Create New Note Card */}
          <Card
            size="small"
            style={{
              marginBottom: '16px',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              backgroundColor: '#F9FDFF',
            }}
          >
            <TextArea
              placeholder="Enter your note here..."
              value={this.props.curr_note}
              data-testid="notes-add-input"
              onChange={this.handleChange}
              onPressEnter={this.handleKeyPress}
              autoSize={{ minRows: 2, maxRows: 4 }}
              bordered={false}
              style={{
                resize: 'none',
                fontSize: '14px',
                lineHeight: '1.5',
                backgroundColor: '#F9FDFF',
              }}
            />
          </Card>

          {/* Previous Notes */}
          {this.props.notes.length > 0 && <ViewNotes />}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    postNote: data => dispatch(actions.postNote(data)),
  };
};

const mapStateToProps = state => {
  return {
    notes: state.events.notes,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Notes));
